import {
  brandIsPh,
  brandIsPw,
  isTestStage,
} from '@/shared/config/brand-by-target.mjs';

export const isGamingLimitsEnabled = (): boolean =>
  isTestStage && (brandIsPh || brandIsPw);
